const INFO = {
	main: {
		title: "Portfolio",
		name: "Anushka Singh",
		email: "anushka.sng2002@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: " https://x.com/Anushka71147377",
		github: "https://github.com/Anushka-Singh1",
		linkedin: "https://www.linkedin.com/in/anushka-sng2002/",
	},

	homepage: {
		title: "Bridging Code and Creativity: Frontend Developer with a Passion for UI Design",
		description:
			"I am a frontend developer working with ReactJS, designing in Figma, and developing websites using core JavaScript, Tailwind CSS, Bootstrap, ReactJS, NextJS, and Firebase. I enjoy solving complex problems and learning new skills. My passion lies in creating high-quality code that adheres to best practices and industry standards. I am always on the lookout for new challenges and opportunities to grow as a developer.",
	},

	about: {
		title: "I’m Anushka Singh. I live in Bengaluru, where I design the future.",
		description: "",
	},

	// articles: {
	// 	title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
	// 	description:
	// 		"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	// },

	projects: [
		{
			title: "UI-Stories",
			description:
				"A library of reusable, responsive UI components built with React, TypeScript, and Tailwind CSS. Integrated with Storybook for interactive documentation, testing, and visual previews to enhance collaboration and maintainability.",
			logo: "https://www.svgrepo.com/show/354397/storybook-icon.svg",
			linkText: "View Project",
			link: "https://ui-stories.vercel.app/",
		},

		{
			title: "Sorting Visualizer",
			description:
				"Designed and developed a dynamic visualizer for 5 sorting algorithms using HTML, CSS, and JavaScript. Utilized captivating animations to bring sorting algorithms to life.",
			logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/768px-JavaScript-logo.png",
			linkText: "View Project",
			link: "https://sortsnap.netlify.app/",
		},

		// {
		// 	title: "Apni Dukaan",
		// 	description:
		// 		"A modern e-commerce platform developed with React and Vite, featuring efficient global state management using Context API and Reducer. Includes secure Auth0 authentication and a fully responsive, dynamic UI styled with Tailwind CSS.",
		// 	logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTDe7ZWZygE1eHBl35Zkmt730YwJKtCN_l_8A&s",
		// 	linkText: "View Project",
		// 	link: "https://apni-dukaaaan.netlify.app/",
		// },
	],
};

export default INFO;
